

import WebFontLoader from 'webfontloader'

// async load fonts
WebFontLoader.load({
  google: {
    families: [
      'Material+Icons',
    ],
  },
  custom: {
    families: [
      'Font Awesome 5',
    ],
    sources: [
      'https://use.fontawesome.com/releases/v5.8.1/css/all.css',
    ],
  },
})
